import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteTransferenciaContaBancoCaixa } from '../service';
import {
  DELETE_TRANSF_CONTA_BANCO_CAIXA,
  DELETE_TRANSF_CONTA_BANCO_CAIXA_PENDING,
  DELETE_TRANSF_CONTA_BANCO_CAIXA_SUCCESS,
  DELETE_TRANSF_CONTA_BANCO_CAIXA_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteTransferenciaContaBancoCaixa(action) {
  yield put({ type: DELETE_TRANSF_CONTA_BANCO_CAIXA_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.TRANSFERENCIA_BANCO_CAIXA_EXCLUIR);

  try {
    let a = yield call(deleteTransferenciaContaBancoCaixa, action.id);

    if (a.status !== 204) {
      throw a;
    }
    yield put({ type: DELETE_TRANSF_CONTA_BANCO_CAIXA_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_TRANSF_CONTA_BANCO_CAIXA_FAILURE });

    if (error.response?.status === 409) {
      const mensagem = error.response?.data?.message || 'Não é possível excluir esta transferência.';
      AlertWarning(mensagem);
    } else {
      AlertError('Falha ao excluir o registro! Verifique...');
    }
  }
}

export default function* watchDeleteTransferenciaContaBancoCaixa() {
  yield takeLatest(DELETE_TRANSF_CONTA_BANCO_CAIXA, sagaDeleteTransferenciaContaBancoCaixa)
}
